import React from 'react';
import { Trophy, Megaphone } from 'lucide-react';
import { StatusTag, EmptyState, CollapsibleCard } from '../../common';
import ImageGrid, { NoImages } from './ImageGrid';
import { getImageUrl, categoryDisplayName } from './images.controller';

/** One side (ours / competition) of a category's promo gallery. */
function PromoGallery({ label, tone, images, alt }) {
    return (
        <div>
            <div className="flex items-center justify-between mb-2">
                <span className="text-xs font-medium text-surface-500">{label}</span>
                <StatusTag tone={tone} className="tabular-nums">
                    {images.length}
                </StatusTag>
            </div>
            {images.length > 0 ? <ImageGrid images={images} getImageUrl={getImageUrl} alt={alt} height={80} /> : <NoImages label="Sin promos" />}
        </div>
    );
}

function PromotionalActivity({ storeCheck }) {
    const categories = storeCheck?.categories || [];
    const categoriesWithPromos = categories.filter((cat) => cat?.ourPromos?.length > 0 || cat?.theirPromos?.length > 0);

    return (
        <CollapsibleCard
            title="Actividad Promocional"
            icon={<Trophy />}
            iconTone="warning"
            badges={<StatusTag tone="neutral">{categoriesWithPromos.length} categorías</StatusTag>}>
            {categoriesWithPromos.length === 0 ? (
                <EmptyState icon={<Megaphone />} title="Sin actividad promocional" description="No hay actividad promocional registrada" />
            ) : (
                <div className="grid gap-4 grid-cols-1 md:grid-cols-2 xl:grid-cols-3">
                    {categoriesWithPromos.map((category, index) => {
                        const categoryName = categoryDisplayName(category);
                        return (
                            <div key={index} className="rounded-xl border border-surface-200 p-4 flex flex-col gap-4">
                                <h3 className="m-0 text-sm font-semibold text-surface-900">{categoryName}</h3>
                                <PromoGallery label="Nuestra" tone="brand" images={category?.ourPromos || []} alt="Nuestra promo" />
                                <PromoGallery label="Competencia" tone="warning" images={category?.theirPromos || []} alt="Competencia promo" />
                            </div>
                        );
                    })}
                </div>
            )}
        </CollapsibleCard>
    );
}

export default PromotionalActivity;
